import { Circle, styled, Text } from "tamagui";

export const ScoreText = styled(Text, {
  name: "Score",
  fontFamily: "$subtitle",
  variants: {
    variant: {
      success: {
        color: "$score-8",
      },
      warning: {
        color: "$warning-500",
      },
      neutral: {
        color: "$gray-600",
      },
      critical: {
        color: "$score-2-1",
      },
      danger: {
        color: "$error-500",
      },
    },
    font: {
      lg: {
        fontWeight: "$4",
        fontSize: "$6",
        lineHeight: "$6",
      },
      md: {
        fontWeight: "$4",
        fontSize: "$4",
        lineHeight: "$4",
      },
    },
  } as const,
  defaultVariants: {
    variant: "neutral",
    font: "lg",
  },
});

const ScoreCircle = styled(
  Circle,

  {
    name: "Score",
    borderRadius: 9999,
    borderWidth: "$0.2",
    variants: {
      variant: {
        success: {
          borderColor: "$score-8",
          backgroundColor: "$mint-50",
        },
        warning: {
          borderColor: "$warning-500",
          backgroundColor: "$warm-light-50",
        },
        neutral: {
          borderColor: "$gray-600",
          backgroundColor: "$gray-light-50",
        },
        critical: {
          borderColor: "$score-2-1",
          backgroundColor: "$warm-light-150",
        },
        danger: {
          borderColor: "$error-500",
          backgroundColor: "$warm-light-100",
        },
      },
      size: {
        lg: {
          height: "$7.8",
          width: "$7.8",
        },
        md: {
          height: "$5",
          width: "$5",
        },
      },
    } as const,
    defaultVariants: {
      variant: "neutral",
      size: "lg",
    },
  },
);

type ScoreProps = React.ComponentProps<typeof ScoreCircle>;

export const Score: React.FC<
  Omit<ScoreProps, "children" | "size"> & {
    children: string | number | null | undefined;
    size?: "md" | "lg";
  }
> = ({ children, variant, size, ...rest }) => {
  return (
    <ScoreCircle variant={variant} size={size} {...rest}>
      <ScoreText variant={variant} font={size}>
        {children}
      </ScoreText>
    </ScoreCircle>
  );
};
